import { Link } from "react-router-dom";

export default function Logo({ light = false, compact = false }) {
  return (
    <Link to="/" className="group inline-flex items-center gap-2.5">
      <span
        className={`relative grid h-10 w-10 place-items-center rounded-2xl ${
          light ? "bg-gold text-ink" : "bg-ink text-gold"
        }`}
      >
        <svg viewBox="0 0 32 32" className="h-6 w-6" aria-hidden="true">
          <path
            d="M8 22c2.5-8 7-14 8-14s5.5 6 8 14"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
          />
          <circle cx="16" cy="9" r="1.6" fill="#d4527a" />
        </svg>
      </span>
      {!compact && (
        <span className="leading-tight">
          <span
            className={`block font-serif text-xl tracking-tight ${
              light ? "text-cream" : "text-ink"
            }`}
          >
            Aurelia
          </span>
          <span
            className={`block text-[10px] font-semibold uppercase tracking-[0.28em] ${
              light ? "text-gold-soft" : "text-rose"
            }`}
          >
            Celebrations
          </span>
        </span>
      )}
    </Link>
  );
}
